import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { VStack } from '@cbhq/cds-web/layout';

import { DesktopLayout } from './DesktopLayout';
import { Header } from './Header';
import { MobileLayout } from './MobileLayout';
import { PageLayoutProps } from './props';

export function PageLayout({ inSecurityFrame }: PageLayoutProps) {
  const { isPhone } = useBreakpoints();
  const Layout = isPhone ? MobileLayout : DesktopLayout;

  return (
    <VStack>
      <Header />
      <Layout inSecurityFrame={inSecurityFrame} />
    </VStack>
  );
}
